import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import PaymentFailed from "@/pages/checkout/pay-failed/PaymentFailed/PaymentFailed";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useSearchParams } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import Loader from "@componentsShared/Loader/Loader";
import useWebview from "@hooks/useWebview";
import { useEnhancedPromoSystem } from "@/_MiniApps/customized_promo_codes/hooks/useEnhancedPromoSystem";
var CheckoutFailed = function CheckoutFailed() {
  if (__IS_SSR__) return null;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useSession = useSession(),
    user = _useSession.user;
  var order_id = useCheckoutOrder().queryParams.order_id;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading;
  var fetch__getOrderWithPaymentInfo = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfo;
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    removeLocalStorage = _useLocalStorage.removeLocalStorage;
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var webview = useWebview();
  var _useEnhancedPromoSyst = useEnhancedPromoSystem(),
    promoCode = _useEnhancedPromoSyst.promoCode,
    getPromoEventParams = _useEnhancedPromoSyst.getPromoEventParams;
  useEffect(function () {
    if (!order_id) return;
    webview.setBackButtonScreen("cash_flow_user_info_tab")["catch"](function () {
      // please keep the catch
    });
    fetch__getOrderWithPaymentInfo(null, order_id);
  }, [order_id]);
  useEffect(function () {
    var _checkoutOrder$g4_dat;
    if (!checkoutOrder) {
      return;
    }
    var referral_location = getLocalStorage("referral_location") || "";
    var from_car_comparison = referral_location === "car_comparison";
    var submission_source = getSubmissionSource();
    if (from_car_comparison) {
      removeLocalStorage("referral_location");
    }
    var promoCodeData = getPromoEventParams(!(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_code) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code) !== (promoCode === null || promoCode === void 0 ? void 0 : promoCode.code));
    var eventPayload = _objectSpread(_objectSpread(_objectSpread({}, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer), {}, {
      post_trim: checkoutOrder.g4_data_layer.post_ext,
      order_id: checkoutOrder.id.toString()
    }, checkoutOrder.payment_type && {
      payment_option: checkoutOrder.payment_type
    }), {}, {
      response_code: checkoutOrder.response_code || null,
      inventory_type_string: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string,
      payment_status: "Fail",
      response_message: checkoutOrder.response_message || null,
      total_amount: parseFloat(checkoutOrder.payed_amount.replace(/,/g, "")) || null,
      discount_code: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code) || null,
      referral_location: submission_source
    }, promoCodeData);
    var isCreditCardOrder = typeof sessionStorage !== "undefined" && !!sessionStorage.getItem("cc_order_".concat(checkoutOrder.id));
    if (isCreditCardOrder) {
      var _checkoutOrder$g4_dat2;
      trackEvents("credit_card_order_submit", {
        post_id: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_id,
        order_id: checkoutOrder.id.toString(),
        payment_method: checkoutOrder.payment_type || null,
        total_amount: eventPayload.total_amount,
        payment_status: "fail",
        response_code: checkoutOrder.response_code || null,
        response_message: checkoutOrder.response_message || null,
        inventory_type: eventPayload.inventory_type,
        post_make: eventPayload.post_make,
        post_model: eventPayload.post_model,
        post_year: eventPayload.post_year,
        post_condition: eventPayload.post_condition,
        post_price: eventPayload.post_price,
        platform: "web",
        referral_location: submission_source
      });
    } else {
      trackEvents("cash_order_submit", eventPayload);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id]);
  if (!checkoutOrder) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    headHideLinks: true,
    hideAppBanner: true
  }, /*#__PURE__*/React.createElement(PaymentFailed, {
    checkoutOrder: checkoutOrder,
    offlineToken: searchParams.get("offlineToken")
  }));
};
export default CheckoutFailed;